import res from './res'

res.add('kk', {
    title: (reference: string) => `РРН төлем ${reference}`,
    geolocationTitle: 'Геолокация'
})
